/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface VisionEventsControllerDeleteEvent$Params {
  uuid: string;
  eventUuid: string;
}

export function visionEventsControllerDeleteEvent(http: HttpClient, rootUrl: string, params: VisionEventsControllerDeleteEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, visionEventsControllerDeleteEvent.PATH, 'delete');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('eventUuid', params.eventUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

visionEventsControllerDeleteEvent.PATH = '/match-videos/{uuid}/events/{eventUuid}';
